// extracted by mini-css-extract-plugin
module.exports = {"gradientText":"page_gradientText__dHLEC","move-bg":"page_move-bg__s1Tsd"};